import {createAction} from '@reduxjs/toolkit';

const CLEAN_CHANGE_REQUESTS = 'CLEAN_CHANGE_REQUEST';

export const cleanChangeRequests = createAction(CLEAN_CHANGE_REQUESTS);
